(function () {
    'use strict';

    angular.module('vouchr.apiModule', [])
        .config(['$httpProvider', function($httpProvider){
            $httpProvider.defaults.withCredentials = true;
        }]).run(function(){
        });
})();